import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SessionService } from '../services/session.service';
import { BlockedFunctionalService } from '../services/blocked-functional.service';

export const featureGuard = (route: ActivatedRouteSnapshot) => {
	const sessionService: SessionService = inject(SessionService);
	const blockedFunctionalService: BlockedFunctionalService = inject(BlockedFunctionalService);

	const hasFeature: boolean = route.data?.feature ? sessionService.hasFeature(route.data.feature) : true;

	if (!hasFeature && route.data?.blockedType) {
		blockedFunctionalService.openBlockedFunctionalModal(route.data?.blockedType);
	}

	return hasFeature;
}
